import {SharedStrings} from '@colonist/types'

export class EntryOpenApp {
    constructor() {
        // This page is only reached if the app is not installed (universal links would have opened the app)
        // So we redirect to the appropriate app store
        this.redirectToDownloadStore()
    }

    // eslint-disable-next-line class-methods-use-this
    private redirectToDownloadStore() {
        const userAgent = navigator.userAgent.toLowerCase()
        const isIOS = /iphone|ipad|ipod/.test(userAgent)
        const isMacOS = /macintosh|mac os x/.test(userAgent)

        let storeUrl = SharedStrings.PLAY_STORE_URL

        if(isIOS || isMacOS) {
            storeUrl = SharedStrings.APP_STORE_URL
        } else {
            storeUrl = SharedStrings.PLAY_STORE_URL
        }

        window.location.href = storeUrl
    }
}

new EntryOpenApp()
